import { type EpgInfo, type TvChannel } from '@setplex/tria-api'
import { exists } from '~/shared/helpers'
import {
  type EpgSidebarInfo,
  type EpgSidebarProgramInfo,
  type EpgSidebarProgramLocalizedInfo,
} from './index.h'

export const formatProgramToView = ({
  channel,
  program,
}: {
  channel: Readonly<TvChannel>
  program: Readonly<EpgInfo>
}): EpgSidebarProgramInfo => ({
  actors: program.actors,
  categories: program.categories,
  channelName: `${channel.channelNumber}. ${channel.name}`,
  description: program.description,
  directors: program.directors,
  episode: program.episode,
  icon: program.icon,
  logoUrl: channel.logoUrl,
  subtitle: program.subtitle,
  date: program.date,
  rating: program.rating,
  title: program.title,
  actualStartMs: program.actualStartMs,
  actualStopMs: program.actualStopMs,
})

export const formatToView = (
  info: EpgSidebarProgramLocalizedInfo
): EpgSidebarInfo => ({
  actors: info.actors,
  categories: info.categories,
  channelName: info.channelName,
  description: info.description,
  directors: info.directors,
  episode: info.episode,
  icon: info.icon,
  isLive: info.isLive,
  isLoading: false, // defaultSideBar.isLoading, // ???
  labels: info.labels,
  logoUrl: info.logoUrl,
  subtitle: info.subtitle,
  tags: [info.date, info.rating, ...info.categories].filter(exists),
  title: info.title,
})
